import { render, staticRenderFns } from "./before-posting-dialog.vue?vue&type=template&id=72f5d668&"
import script from "./before-posting-dialog.vue?vue&type=script&lang=js&"
export * from "./before-posting-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports